<template>
    <div class="mt-5">
        <div class="control has-top-border">
            <div class="is-flex">
                <h1 class="title">Lines</h1>
                <font-awesome-icon class="collapsable-icon ml-3 mt-1" :icon="determineIcon()" @click="isCollapsed = !isCollapsed" />
            </div>
        </div>
        <div v-if="!isCollapsed">
            <Loading v-if="isLoading" />
            <div v-else-if="lineListEmpty">
                <p class="field">
                    This account has no lines.
                </p>
            </div>
            <div v-else>
                <div class="field">
                    <router-link to="/lines">
                        <button class="button is-primary" @click="setAccountPublicId">
                            Go to Full Line List
                        </button>
                    </router-link>
                </div>
                <div class="table-container">
                    <table class="table is-striped is-fullwidth has-top-border has-bottom-border">
                        <thead>
                            <tr>
                                <th>Id</th>
                                <th><abbr title="Public Id">PId</abbr></th>
                                <th>Name</th>
                                <th>Phone Number</th>
                                <th>Enabled</th>
                                <th></th>
                            </tr>
                        </thead>

                        <tbody>
                            <tr v-for="(line, index) in accountLines" :key="'line' + index">
                                <td> {{ line.lineId }}</td>
                                <td>
                                    <router-link :to="'/line/' + line.publicLineId">{{ line.publicLineId }}</router-link>
                                </td>
                                <td>
                                    <router-link :to="'/line/' + line.publicLineId">{{ line.lineName }}</router-link>
                                </td>
                                <td> {{ line.phoneNumber }}</td>
                                <td> {{ line.isEnabled}}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <Pagination :isLoading="isLoading" :currentPage="currentPage" :totalPages="totalPages" v-on:setPage="n => setPage(n)" />
            </div>
        </div>
    </div>
</template>

<script>
    import { securePost } from '../secureFetch.js';

    import Loading from "./Loading.vue";
    import Pagination from './Pagination';

    export default {
        name: "AccountLines",
        components: {
            Loading,
            Pagination
        },
        props: {
            accountPublicId: {
                type: String,
                default: null
            },
            isCollapsed: {
                type: Boolean,
                default: true
            },
        },
        watch: {
            accountPublicId(value) {
                if (value) {
                    this.loadAccountLines = true;
                }           
            },
            errorMessage(value) {
                this.$emit("error", value);
            },
            loadAccountLines(value) {
                if (value) {
                    this.getAccountLines();
                }
            }
        },
        mounted() {
            if (this.accountPublicId) {
                this.loadAccountLines = true;
            }
        },
        computed: {
            hostUrl: function () {
                return this.$store.state.hostUrl;
            },
            currentPage: {
                set(value) {
                    this.$store.commit('updateLinePageFilter', value);
                },
                get() {
                    return this.$store.state.lineFilters.page;
                }
            }
        },
        data() {
            return {
                isLoading: true,
                lineListEmpty: false,
                accountLines: [],
                totalPages: 0,
                resultsPerPage: 10,
                errorMessage: null,
                defaultErrorMessage: "Something didn't work.",
                loadAccountLines: false,
            }
        },
        methods: {
            setAccountPublicId() {
                this.$store.commit('updateLineAccountIdFilter', this.accountPublicId);
            },
            getAccountLines() {
                this.isLoading = true;
                this.totalPages = 0;
                var body = {
                    accountPublicId: this.accountPublicId,
                    integrationTypeCode: null,
                    page: this.currentPage,
                    searchTerm: "",
                    serviceTypeCode: null,
                    resultsPerPage: this.resultsPerPage,
                };
                securePost(this.hostUrl + "v1/line/search-customer-lines", body)
                    .then((data) => {
                        if (data && data.success) {
                            this.accountLines = data.customerLines;
                            this.currentPage = data.currentPage;
                            this.totalPages = data.totalPages;
                            this.lineListEmpty = !data.customerLines.length;
                        } else {
                            this.errorMessage = data.message;
                            if (!this.errorMessage) {
                                this.errorMessage = this.defaultErrorMessage;
                            }
                        }
                        this.isLoading = false;
                    })
                    .catch((e) => {
                        this.isLoading = false;
                        this.errorMessage = this.defaultErrorMessage;
                        console.error(e);
                    });
            },
            setPage(page) {
                this.currentPage = page;
                this.getAccountLines();
            },
            determineIcon() {
                if (this.isCollapsed) {
                    return ['fa', 'angle-up'];
                }
                return ['fa', 'angle-down'];
            }
        }
    }
</script>

<style scoped>
    .has-bottom-border {
        border-bottom: 1px solid #808080;
        padding-bottom: 1em;
    }

    .feature-list:first-child {
        border-top: 1px solid #808080;
        padding-top: 1em;
    }

    .has-background-alt {
        background-color: #141514;
        margin-top: -1.425em;
    }

    .collapsable-icon {
        height: 32px;
        width: 32px;
    }

    .template-button {
        min-width: 25em;
    }
</style>